<h3 class="ui header light user-step-title">
  Teaching and Learning Activities</h3>


<div *ngIf="loading.isLoading;else loaded">
  <app-loading [loadingText]="loading.text"></app-loading>
</div>

<ng-template #loaded>

  <app-load-error *ngIf="loadError; else noErrors" [loadError]="loadError">
  </app-load-error>

  <ng-template #noErrors>

    <div class="user-step-instruction">
      Add the teaching and learning activities used in this course. List all that are used.
    </div>



    <!-- <app-action-errors *ngIf="actionErrors.length > 0" [title]="actionErrorTitle" [actionErrors]="actionErrors">
    </app-action-errors> -->


    <div>


      <div *ngIf="!tlaFormat.isEnabled" class="ui message">
        You are not required to define teaching and learning activities for this curriculum review.
      </div>

      <div *ngIf="tlaFormat.isEnabled && selectedTlaOptions && selectedTlaOptions.length == 0" class="ui message">
        You have not listed any teaching and learning activities for this course.
      </div>

      <div *ngIf="tlaFormat.isEnabled && selectedTlaOptions && selectedTlaOptions.length > 0">

        <table class="ui table tla-table">

          <tr class="header-row">
            <td>Teaching and Learning Activity</td>
            <td *ngIf="tlaFormat.isExtentRequired">Extent of use
              <!-- <div class="tooltip">
                <i class="question circle icon"></i>
                <span class="tooltip-text top">Explain Extend of Use here</span>
              </div> -->
              <span class="tooltip-wrapper" data-tooltip="TODO: Extent of use" data-position="top left"
                data-inverted="">
                <i class="question circle icon"></i>
              </span>



            </td>
            <td></td>
          </tr>

          <tr *ngFor="let tla of selectedTlaOptions">
            <td>{{ tla.description }}
              <span *ngIf="tla.additionalText">:
                <br>{{tla.additionalText}}</span>
            </td>
            <td *ngIf="tlaFormat.isExtentRequired">

              <div *ngIf="tlaFormat.extentFormat == 'text'">
                {{tla.extentText}}
              </div>

              <div *ngIf="tlaFormat.extentFormat == 'list'">


                <div *ngIf="tla.extentOption ">

                  {{ tla.extentOption.description }}

                  <span *ngIf="tla.extentOption.otherText">:
                    <br>{{tla.extentOption.otherText}}</span>
                </div>

                <!-- <div *ngIf="!tla.extentOption || !tla.extentOption " class="not-specified">
                  Not Specified
                </div> -->

              </div>


            </td>
            <td class="button-col">


              <button class="ui basic button mini" (click)="openEditTlaForm(tla)">
                <i class="edit icon"></i>Edit</button>
              <button class="ui basic button mini delete-button" (click)="confirmDeleteTla(tla)">
                <i class="trash alternate outline icon"></i>Delete</button>
            </td>
          </tr>

        </table>

      </div>


      <div class="add-button-area" *ngIf="tlaFormat.isEnabled">
        <button class="ui primary button action tiny save-button" (click)="openAddTlaForm()">
          <i class="icon plus"></i>Add Teaching and Learning Activity</button>
      </div>

    </div>


    <!-- <div class="ui divider step-navigation"></div> -->


    <!-- <div class="button-area"> -->

    <!--<div class="add-button-area">
                  <button class="ui primary button action save-button" (click)="openAddTlaForm()">Add teaching and learning activity</button>
                </div>-->
    <!-- 
      <div class="nav-button-area">
        <button class="ui left labeled icon button tiny prev-step-button" (click)="previousStepClicked()">
          <i class="left arrow icon"></i>Previous - Student assessment methods</button>
        <button class="ui right labeled icon  button tiny next-step-button" (click)="nextStepClicked()">
          <i class="right arrow icon"></i>Next - Course outcomes</button>
      </div> -->
    <!-- </div> -->


  </ng-template>


</ng-template>


<!-- tla form -->
<div *ngIf="shouldShowForm" class="modal-window" [ngClass]="{'show': shouldShowForm, 'hide': !shouldShowForm}">


  <div class="modal-window-header">
    Teaching and Learning Activity</div>

  <div class="modal-window-content ui form">

    <div class="modal-instruction">
      Enter information about teaching and learning activities.
    </div>

    <!-- <div class="form-area"> -->

    <!-- <div class="fields"> -->

    <div class="required field">
      <label>Teaching and learning activity</label>
      <!--<div class="field-instruction">Please select from the list.</div>-->

      <div class="ui pointing below red basic label" *ngIf="!isTlaSelected">
        Please select/define teaching and learning activity.
      </div>

      <div *ngIf="tlaFormat.format == 'list'">

        <select class="ui dropdown" name="tlaActivity" [ngModel]="tlaOptionForForm.id"
          (ngModelChange)="tlaOptionSelected($event)">
          <option [ngValue]="null">-- Select teaching and learning activity --</option>
          <option *ngFor="let tlaOption of tlaOptions" [ngValue]="tlaOption.id">{{tlaOption.description}}
            <span *ngIf="tlaOption.isTextRequired">(Please describe)</span>
          </option>
        </select>

      </div>

      <div *ngIf="tlaFormat.format == 'text'">
        <input type="text" [(ngModel)]="tlaOptionForForm.description" />
      </div>



    </div>

    <div class="field" [ngClass]="{required: tlaOptionForForm.isTextRequired}">


      <label>Description
        <span *ngIf="!tlaOptionForForm.isTextRequired">(Optional)</span>
      </label>

      <div class="label-description">
        Please describe this teaching and learning activity (if necessary).
      </div>

      <input type="text" class="ui input other-text-box" placeholder="Please describe teaching and learning activity"
        [(ngModel)]="tlaOptionForForm.additionalText" />

      <div class="ui pointing red basic label" *ngIf="tlaOptionForForm.isTextRequired && !isTlaOptionOtherTextFilled">
        Please describe this teaching and learning activity.
      </div>

    </div>



    <div class="field extent" *ngIf="tlaFormat.isExtentRequired">

      <label>Extent of use
      </label>

      <div class="label-description">
        Extent of use instruction
      </div>

      <div class="ui pointing below red basic label" *ngIf="!isTlaExtentOptionSelected">
        Please select/define extent of use.
      </div>


      <div class="ui form extent-options">


        <div *ngIf="tlaFormat.extentFormat == 'text'">
          <input type="text" [(ngModel)]="tlaOptionForForm.extentText" />
        </div>

        <div *ngIf="tlaFormat.extentFormat == 'list'" class="field">
          <div *ngFor="let extentOption of tlaExtentOptionsForForm">

            <div class="ui radio checkbox">
              <input type="radio" [attr.name]="extent-option-radio" [checked]="extentOption.isSelected"
                (change)="extentOptionSelected(extentOption.id)" [disabled]="saving">
              <label>{{extentOption.description}}</label>
            </div>

            <input type="text" class="extent-other-text-box" placeholder="Please describe"
              *ngIf="extentOption.isSelected && extentOption.isTextRequired" [(ngModel)]="extentOption.otherText" />




          </div>
        </div>



        <!-- 
        <div class="field extent-description" *ngIf="tlaFormat.isExtentRequired" [ngClass]="{required: tlaOptionForForm.extentTextRequired}">

          <label>Extent of Use Description
            <span *ngIf="!tlaOptionForForm.extentTextRequired">(Optional)</span>
          </label>
          <input type="text" class="ui input other-text-box" placeholder="Please describe extent of use" [(ngModel)]="tlaExtentOptionDescriptionForForm"
          />

          <div class="ui pointing red basic label" *ngIf="tlaOptionForForm.extentTextRequired && !isTlaExtentOptionOtheTextFilled">
            Please specify extent of use selected above.
          </div>

        </div> -->


      </div>

    </div>

  </div>

  <div class="modal-actions">
    <span class="updatingForm" *ngIf="formProcessing">Updating..</span>
    <button class="ui primary button tiny approve" (click)="submit()" [disabled]="formProcessing"
      [ngClass]="{'loading': formProcessing}">Save</button>
    <button class="ui basic button tiny deny" (click)="closeForm()" [disabled]="formProcessing">Cancel</button>

  </div>

</div>

<!-- Delete dialog -->
<app-dialog [dialog]="dialog" [updating]="dialogUpdating" (closeDialog)="closeDialog()"
  (submitDialog)="proceedDeleteTla()">
</app-dialog>
<!-- End Delete Dialog -->

<!-- 
<app-user-step-tla-form *ngIf="shouldShowForm" class="modal-window" [ngClass]="{'show': shouldShowForm, 'hide': !shouldShowForm}"
  [courseId]="courseId" [tlaFormat]="tlaFormat" [tlaFormValue]="tlaFormValue" [selectedTlas]="selectedTlas" [action]="action"
  (submit)="submit()" (update)="update()" (cancel)="cancelForm()"></app-user-step-tla-form>

<app-saving-status *ngIf="shouldShowSavingStatus" class="in-progress-modal-window" [title]="savingStatusTitle" [text]="savingStatusText"
  [status]="savingStatus" (cancel)="cancelDelete()" (closeSavingStatus)="closeSavingStatus()" (proceed)="proceedDelete()"></app-saving-status> -->